import axios from '../../../plugins/Axios/axios';

const state = {};

const getters = {};

const actions = {
    GET_FOLDERS_TEMPLATE({ commit }) {
        return axios.get(`/courselearning/folders`).then((response) => response.data.data);
    },
    GET_FOLDER_TEMPLATE({ commit }, request) {
        const { id: crfolderId } = request;
        return axios.get(`/courselearning/folders/${crfolderId}`).then((response) => response.data.data);
    },
    CREATE_FOLDER_TEMPLATE({ commit }, request) {
        return axios.post(`/courselearning/folders`, request).then((response) => response.data.data);
    },
    UPDATE_FOLDER_TEMPLATE({ commit }, request) {
        const { id: crfolderId, ...folder } = request;
        return axios.patch(`/courselearning/folders/${crfolderId}`, folder).then((response) => response.data.data);
    },
    DELETE_FOLDER_TEMPLATE({ commit }, request) {
        const { id: crfolderId } = request;
        return axios.delete(`/courselearning/folders/${crfolderId}`).then((response) => response.data.data);
    }
};

const mutations = {
    clear: (state) => {}
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
